import { computeSavedEntityState } from 'state/utils/computeSavedEntityState';
import { dashboard } from 'types';
import { toJSONArray } from '@tock/coretypes';
import { todayBusinessDay } from '@tock/shared/utils/time';
import AppConstants from 'constants/AppConstants';

interface FloorPlanSavedState {
  activeTables: dashboard.Table[];
  archivedTables: dashboard.Table[];
  tableCombinations: dashboard.TableCombination[];
}

interface SavedState {
  [date: string]: FloorPlanSavedState;
}

interface State {
  activeTables: dashboard.Table[];
  archivedTables: dashboard.Table[];
  tableCombinations: dashboard.TableCombination[];
  tablePrioritiesByTableId: dashboard.TableAssignmentPriorityLevelByTableId[];
  savedState: SavedState;
  inventorySchedule: dashboard.BusinessInventorySchedule[];
  isInitialized: boolean;
}

const initialState: State = {
  activeTables: [],
  archivedTables: [],
  tableCombinations: [],
  tablePrioritiesByTableId: [],
  savedState: {},
  inventorySchedule: [],
  isInitialized: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.CALENDAR_FLOORPLAN_FETCH_FOR_SERVICE_DAY_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.CALENDAR_FLOORPLAN_FETCH_FOR_SERVICE_DAY_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case AppConstants.CALENDAR_FLOORPLAN_FETCH_FOR_SERVICE_DAY_DONE: {
      const floorplanForServiceDay = payload;
      return {
        ...state,
        activeTables: toJSONArray(floorplanForServiceDay.activeTable),
        archivedTables: toJSONArray(floorplanForServiceDay.archivedTable),
        tableCombinations: toJSONArray(floorplanForServiceDay.tableCombination),
        tablePrioritiesByTableId: toJSONArray(floorplanForServiceDay.priorityLevelByTableId),
        isInitialized: true,
      };
    }
    case AppConstants.CALENDAR_BUSINESS_INVENTORY_SCHEDULE_FETCH_FOR_SERVICE_DAY: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.CALENDAR_BUSINESS_INVENTORY_SCHEDULE_FETCH_FOR_SERVICE_DAY_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case AppConstants.CALENDAR_BUSINESS_INVENTORY_SCHEDULE_FETCH_FOR_SERVICE_DAY_DONE: {
      return {
        ...state,
        inventorySchedule: [payload],
        isInitialized: true,
      };
    }
    case AppConstants.CALENDAR_ENTITY_SAVE_DATE: {
      const stateToSave: FloorPlanSavedState = {
        activeTables: state.activeTables,
        archivedTables: state.archivedTables,
        tableCombinations: state.tableCombinations,
      };
      const newSavedState: SavedState = computeSavedEntityState<FloorPlanSavedState>({
        newDate: payload,
        stateToSave,
        savedState: state.savedState,
        todayString: todayBusinessDay().toString(),
      });
      return {
        ...state,
        savedState: newSavedState,
      };
    }
    case AppConstants.CALENDAR_ENTITY_RESTORE_DATE: {
      const restoredState = state.savedState[payload];
      if (!restoredState) {
        return {
          ...state,
          activeTables: initialState.activeTables,
          archivedTables: initialState.archivedTables,
          tableCombinations: initialState.tableCombinations,
        };
      }
      return {
        ...state,
        activeTables: restoredState.activeTables,
        archivedTables: restoredState.archivedTables,
        tableCombinations: restoredState.tableCombinations,
      };
    }
    default:
      return state;
  }
}
